import { render, staticRenderFns } from "./userDetails.vue?vue&type=template&id=9ef55a22&"
import script from "./userDetails.vue?vue&type=script&lang=js&"
export * from "./userDetails.vue?vue&type=script&lang=js&"
import style0 from "./userDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports